<app-loading></app-loading>
@if (apiUpstreamPort) {
  <div
    class="api-port-badge"
    [attr.title]="'Reverse proxy /api → apiprofessor :' + apiUpstreamPort"
  >
    API :{{ apiUpstreamPort }}
  </div>
}
<router-outlet></router-outlet>
